import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
} from "@mui/material";
import { RootState } from "../../models/RootState";
import { EventData } from "../../models/EventData";
import { SportRadarEventsTable } from "../../components/EventsTable/SportRadarEventTable";
import { SportRadarEventCard } from "../../components/EventsCards/SportRadarEventCard";
import EventCard from "../../components/EventsCards/EventCard";
import EventsTable from "../../components/EventsTable/EventsTable";
import { SportImgMap } from "../../constants/common-utlits";
import cricket from "../../assets/images/sports/cricket.svg";
import tennis from "../../assets/images/sports/tennis.svg";
import soccer from "../../assets/images/sports/soccer.svg";
import { fetchInplayEvents } from "../../store";
import RightSideNav from "../../components/RightSideNav/RightSideNav";
import "./live-events-page.scss";

type StoreProps = {
  fetchInplayEvents: Function;
  events: { [key: string]: EventData[] };
  providerId: string;
  grid: boolean;
};

const LiveEventsPage: React.FC<StoreProps> = (props) => {
  const { events, fetchInplayEvents, providerId, grid } = props;
  const [expanded, setExpanded] = useState([]);

  useEffect(() => {
    fetchInplayEvents();
  }, [providerId]);

  const handleChange = (key) => {
    let index = expanded.indexOf(key);
    if (index > -1) {
      expanded.splice(index, 1);
      setExpanded([...expanded]);
    } else {
      setExpanded([...expanded, key]);
    }
  };

  return (
    <>
      <div className="left-ctn">
        {events && Object.entries(events).length > 0 ? (
          <div className="live-events-page">
            {Object.entries(events).map(([key, value]) => (
              <Accordion
                expanded={expanded.indexOf(key) > -1 ? false : true}
                key={key}
                className="custom-accordion"
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  onClick={() => handleChange(key)}
                  className="custom-accordion-MuiAccordionSummary-root"
                >
                  <Typography
                    sx={{ width: "40%", flexShrink: 0 }}
                    className="title"
                  >
                    <div>
                      {key === "cricket" ? (
                        <img src={cricket} alt="cricket" />
                      ) : key === "football" ? (
                        <img src={soccer} alt="soccer" />
                      ) : key === "tennis" ? (
                        <img src={tennis} alt="tennis" />
                      ) : null}{" "}
                    </div>{" "}
                    <div>{key}</div>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {value?.length > 0 ? (
                    <>
                      {providerId === "SportRadar" ? (
                        <>
                          {grid ? (
                            <SportRadarEventCard events={value} />
                          ) : (
                            <LiveSportRadar events={value} />
                          )}
                        </>
                      ) : (
                        <>
                          {!grid ? (
                            <EventsTable events={value} />
                          ) : (
                            <EventCard events={value} />
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <div className="message-empty-container">
                      <h5 className="message-empty-message">
                        !!! No Inplay Events !!!
                      </h5>
                    </div>
                  )}
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        ) : (
          <div className="message-empty-container">
            <h5 className="message-empty-message">!!! No Inplay Events !!!</h5>
          </div>
        )}
      </div>

      {/* <div className="right-ctn web-view">
        <RightSideNav
          hideOpenBets={true}
          hideRightCtn={providerId === "SportRadar" ? true : false}
        />
      </div> */}
    </>
  );
};

const LiveSportRadar = (props) => {
  const { events, providerId } = props;
  const eventEnableStatus = ["in_play", "upcoming"];

  return (
    <div className="sportrader-events-tbl-ctn">
      <TableContainer>
        <Table size="small" aria-label="a dense table">
          <TableBody>
            {events && events.length ? (
              events.map((itm, index) => {
                return <SportRadarEventsTable eventData={itm} key={index} />;
              })
            ) : (
              <TableRow>
                <TableCell colSpan={6}> No Events </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    events: state.sportsBook.inplayEvents,
    operatorId: state.auth.operatorId,
    loggedIn: state.auth.loggedIn,
    providerId: state.auth.providerId,
    grid: state.auth.grid,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchInplayEvents: () => dispatch(fetchInplayEvents()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LiveEventsPage);
